import { Component, inject, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SchoolMember } from '../../../../models/member.school.model';
import {
  BtnFabComponent,
  BtnFabPosition,
} from '../../../components/buttons/btn-fab/btn-fab.component';
import { DlgAssignMemberStatusComponent } from '../../dlg-assign-member-status/dlg-assign-member-status.component';

@Component({
  selector: 'app-change-member-status',
  standalone: true,
  imports: [BtnFabComponent],
  templateUrl: './change-member-status.component.html',
  styleUrl: './change-member-status.component.css',
})
export class ChangeMemberStatusComponent {
  @Input() item!: SchoolMember;
  @Input() position: BtnFabPosition = BtnFabPosition.LEFT;

  private dialog: MatDialog = inject(MatDialog);

  constructor() {}

  onChangeStatus() {
    let dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      title: 'Update Member Status(s)',
      description: `Select status to assign to '${this.item.name}'`,
      action: 'Update',
      member: this.item,
    };
    const dialogRef = this.dialog.open(
      DlgAssignMemberStatusComponent,
      dialogConfig
    );

    return dialogRef.afterClosed().subscribe((result) => {
      return;
    });
  }
}
